// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1__ed0f015ac533b9491666","cls2":"Base-cls2__d42085f1eeeb5d9a643d Base-cls1__ed0f015ac533b9491666"};